import { ICON_TCP } from '@shared/config'

export const getCountryUrlByVoucher = (
  voucher: { features?: { country_web?: string } },
  countryVouchers: { country: string; icon: string }[]
) => `${ICON_TCP}${countryVouchers.find((country) => country.country === voucher.features?.country_web)?.icon}` || ''
